import "core-js/modules/es6.regexp.replace";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.loadCustomerService ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCustomerService,
      expression: "showCustomerService"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox component-customer-service",
    class: {
      'show-animation': _vm.showCustomerService,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "main-content"
  }, [(_vm.info.type == 1 || _vm.info.type == 2) && !_vm.fxbInviteCode ? _c('div', {
    staticClass: "section-erweima"
  }, [_c('div', {
    staticClass: "section-top"
  }, [_vm.info.type == 1 ? _c('div', {
    staticClass: "section-official"
  }, [_c('div', {
    staticClass: "official-title"
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/customer_service_dot_left.png"
    }
  }), _c('span', [_vm._v("云客赞小助手")]), _c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/customer_service_dot_right.png"
    }
  })], 1), _c('div', {
    staticClass: "official-time"
  }, [_vm._v("\n                服务时间: " + _vm._s(_vm.info.startTime) + "~" + _vm._s(_vm.info.endTime) + "\n              ")]), _c('div', {
    staticClass: "erweima-wrap"
  }, [_c('ycf-image', {
    staticClass: "pic-erweima",
    attrs: {
      "src": _vm.info.weChatQrCode
    }
  })], 1), _c('div', {
    staticClass: "official-tips"
  }, [_vm._v("长按识别，向我咨询")])]) : _c('div', {
    staticClass: "section-personal"
  }, [_c('div', {
    staticClass: "personal-header"
  }, [_c('ycf-image', {
    staticClass: "personal-avatar",
    attrs: {
      "src": _vm.info.userPic
    }
  }), _c('div', {
    staticClass: "personal-tips"
  }, [_vm._v("\n                  添加好友, 向我咨询\n                ")]), _c('ycf-image', {
    staticClass: "personal-tips-pic",
    attrs: {
      "src": "/srcv2/images/dialog-add.png"
    }
  })], 1), _c('div', {
    staticClass: "personal-username"
  }, [_vm._v(_vm._s(_vm.info.nickName))]), _c('div', {
    staticClass: "erweima-wrap"
  }, [_c('ycf-image', {
    staticClass: "pic-erweima",
    attrs: {
      "src": _vm.info.weChatQrCode
    }
  })], 1)])]), _vm.customer.phone && _vm.customer.phone.length ? _c('div', {
    staticClass: "section-bottom"
  }, [_vm._l(_vm.customer.phone, function (phone, index) {
    return [phone && phone !== '02039437415' && typeof phone == 'string' && phone.replace(/-/g, '') !== '02039437415' ? [_c('div', {
      key: index,
      staticClass: "tele-list",
      class: {
        'more-phone': _vm.customer.phone && _vm.customer.phone.length > 1
      }
    }, [_c('div', {
      staticClass: "cel-left"
    }, [_c('p', {
      staticClass: "tele-header"
    }, [_vm._v("联系商家")]), _c('p', {
      staticClass: "row-2"
    }, [_vm._v(_vm._s(phone))])]), _c('a', {
      staticClass: "cel-right",
      attrs: {
        "href": _vm._f("getPhone")('tel:' + phone)
      }
    }, [_c('ycf-image', {
      staticClass: "cel-right-icon",
      attrs: {
        "src": "/srcv2/images/customer_service_dianhua_2.png"
      },
      on: {
        "click": function click($event) {
          _vm.isProductDetailPage && _vm.generalAnchors('clickMerchantTel');
        }
      }
    })], 1)])] : [_c('div', {
      key: index,
      staticClass: "tele-list"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "cel-right"
    }, [_c('ycf-image', {
      staticClass: "cel-right-icon",
      attrs: {
        "src": "/srcv2/images/customer_service_xiaoneng.png"
      },
      on: {
        "click": _vm.goCustomerServicePage
      }
    })], 1)])]];
  })], 2) : _vm._e(), _vm.xiaoNengSwitchStatus && !(_vm.customer.phone && _vm.customer.phone.length) ? _c('div', {
    staticClass: "section-bottom"
  }, [_c('div', {
    staticClass: "tele-list"
  }, [_vm._m(1), _c('div', {
    staticClass: "cel-right"
  }, [_c('ycf-image', {
    staticClass: "cel-right-icon",
    attrs: {
      "src": "/srcv2/images/customer_service_xiaoneng.png"
    },
    on: {
      "click": _vm.goCustomerServicePage
    }
  })], 1)])]) : _vm._e(), _vm.isMultipleStore && _vm.customer.phone && _vm.customer.phone.length ? _c('div', {
    staticClass: "qrcede-phone-all"
  }, [_c('div', {
    staticClass: "phone-all-btn"
  }, [_c('p', {
    staticClass: "txt-h",
    on: {
      "click": _vm.goStorePage
    }
  }, [_vm._v("其他门店电话 >")])])]) : _vm._e()]) : _c('div', {
    staticClass: "section-phone"
  }, [_c('div', {
    staticClass: "head-title"
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/customer_service_dot_left.png"
    }
  }), _c('span', [_vm._v("客服咨询")]), _c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/customer_service_dot_right.png"
    }
  })], 1), _vm.xiaoNengSwitchStatus && !(_vm.customer.phone && _vm.customer.phone.length) ? _c('div', {
    staticClass: "xiaoneng-content"
  }, [_vm._m(2), _c('ycf-image', {
    staticClass: "cel-right",
    attrs: {
      "src": "/srcv2/images/customer_service_xiaoneng.png"
    },
    on: {
      "click": _vm.goCustomerServicePage
    }
  })], 1) : _vm._e(), _vm.customer.phone && _vm.customer.phone.length ? [_vm._l(_vm.customer.phone || [], function (phone, index) {
    return [phone == '02039437415' || typeof phone == 'string' && phone.replace(/-/g, '') == '02039437415' ? _c('div', {
      key: index,
      staticClass: "xiaoneng-content"
    }, [_vm._m(3, true), _c('ycf-image', {
      staticClass: "cel-right",
      attrs: {
        "src": "/srcv2/images/customer_service_xiaoneng.png"
      },
      on: {
        "click": _vm.goCustomerServicePage
      }
    })], 1) : _c('div', {
      key: index,
      staticClass: "tele-content"
    }, [_c('p', {
      staticClass: "txt-h"
    }, [_vm._v("联系商家")]), _c('div', {
      staticClass: "tele-list"
    }, [_c('div', {
      staticClass: "cel-left"
    }, [_c('p', {
      staticClass: "row-1"
    }, [_vm._v("服务热线")]), _c('p', {
      staticClass: "row-2"
    }, [_vm._v(_vm._s(phone))])]), _c('a', {
      attrs: {
        "href": _vm._f("getPhone")('tel:' + phone)
      }
    }, [_c('ycf-image', {
      staticClass: "cel-right",
      attrs: {
        "src": "/srcv2/images/customer_service_dianhua_2.png"
      },
      on: {
        "click": function click($event) {
          _vm.isProductDetailPage && _vm.generalAnchors('clickMerchantTel');
        }
      }
    })], 1)])])];
  })] : _vm._e(), _vm.isMultipleStore && _vm.customer.phone && _vm.customer.phone.length ? _c('div', {
    staticClass: "phone-all"
  }, [_c('div', {
    staticClass: "phone-all-btn"
  }, [_c('p', {
    staticClass: "txt-h",
    on: {
      "click": _vm.goStorePage
    }
  }, [_vm._v("其他门店电话 >")])])]) : _vm._e()], 2)]), _c('div', {
    staticClass: "main-foot",
    on: {
      "click": _vm.hideBox
    }
  }, [_c('i')])])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cel-left"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("在线客服")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("咨询时间：09:00-22:00")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cel-left"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("在线客服")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("咨询时间：09:00-22:00")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cel-left"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("在线客服")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("咨询时间：09:00-22:00")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cel-left"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("在线客服")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("咨询时间：09:00-22:00")])]);
}];
export { render, staticRenderFns };